var _path, _path2, _path3, _path4, _path5;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserPlus(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99972 10.2857C9.57768 10.2857 10.8569 9.00654 10.8569 7.42858C10.8569 5.85063 9.57768 4.57144 7.99972 4.57144C6.42176 4.57144 5.14258 5.85063 5.14258 7.42858C5.14258 9.00654 6.42176 10.2857 7.99972 10.2857Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.41406 13.0981C3.8445 12.2519 4.50072 11.5412 5.31008 11.0448C6.11945 10.5484 7.05038 10.2857 7.99983 10.2857C8.94929 10.2857 9.88022 10.5484 10.6896 11.0448C11.499 11.5412 12.1552 12.2518 12.5856 13.0981",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4277 2.85715H14.8563",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1426 1.14285V4.57142",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7719 6.91842C14.9988 8.34739 14.7675 9.81154 14.1111 11.1009C13.4547 12.3903 12.4068 13.4388 11.1178 14.096C9.82873 14.7531 8.36471 14.9852 6.93561 14.7591C5.50652 14.5329 4.18573 13.86 3.16263 12.8369C2.13953 11.8138 1.46665 10.493 1.24047 9.06391C1.01429 7.63481 1.24642 6.17079 1.90359 4.88176C2.56075 3.59272 3.6092 2.54487 4.8986 1.88844C6.18801 1.232 7.65216 1.00069 9.08112 1.22768",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlus);
export default __webpack_public_path__ + "static/media/user-plus.d759d8f52beb531f6b28052de548c6e3.svg";
export { ForwardRef as ReactComponent };